import { isApiRecord, type ApiValue } from '../../api/responseDecoders'

export interface CheckoutResultState {
  outcome: 'success' | 'failure'
  orderId: string | null
}

export function readCheckoutResultState(state: ApiValue): CheckoutResultState | null {
  if (!isApiRecord(state) || !isApiRecord(state.checkoutResult)) return null
  const result = state.checkoutResult
  if (result.outcome !== 'success' && result.outcome !== 'failure') return null
  if (result.orderId !== null && (typeof result.orderId !== 'string' || result.orderId === '')) return null
  return { outcome: result.outcome, orderId: result.orderId }
}
